var Filters = {
	init:function(){

		$(".shop-top-widget .filters-title").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}

			if($(".shop-top-widget").hasClass("open")){
				Filters.close_filters();
			}else{
				Filters.open_filters();
			}

		})
		Filters.generate_link();
	},
	open_filters:function(){
		$(".shop-top-widget").addClass("open");

		var _h = 0;

		$(".shop-top-widget .widget").each(function(){

			if($(this).outerHeight() > _h){
				_h = $(this).outerHeight();
			}
		});

		$(".shop-top-widget .filters-content").css({height:_h +20});


	},
	close_filters:function(){
		$(".shop-top-widget").removeClass("open");
		$(".shop-top-widget .filters-content").css({height:0});
	},
	generate_link:function(){
		$('.wc-layered-nav-term').on('click', function(e){
			e.preventDefault();
			var filter = $(this);
			var term_id = filter.find('.term-infos').data('term');
			var taxonomy = filter.find('.term-infos').data('taxonomy');
			var link = $('.show-results').attr("href");
			var action = 'add_to_filter_link';
			if(filter.hasClass('chosen')){
				action = 'remove_from_filter_link';
			}
			Debug.log(action);
			data = {
				action:action,
				link:link,
				term_id:term_id,
				taxonomy:taxonomy
			}
			$.ajax({
				url: ajaxurl,
				type:'POST',
				data: data,
				beforeSend:function(){
					$(".shop-top-widget .right").addClass("loading");

				},
				success: (results) => {
          console.log($(".show-results").attr('href'))
					$(".shop-top-widget .right").removeClass("loading");
					$('.show-results').attr("href",results);
					if('remove_from_filter_link' === action){
						filter.removeClass('chosen');
						filter.removeClass('woocommerce-widget-layered-nav-list__item--chosen');
					}else{
						filter.addClass('chosen');
						filter.addClass('woocommerce-widget-layered-nav-list__item--chosen');
					}
          if (filter.parent().parent().parent().hasClass("filter-bar")) {
            window.location.replace($(".show-results").attr("href"));
          }
				}
			});
		});

		$(document.body).on('price_slider_change', function(){
			var link = $('.show-results').attr("href");
			data = {
				action:'update_filter_price',
				min_price:$('#min_price').val(),
				max_price:$('#max_price').val(),
				link:link
			}
      console.log(data);
			$.ajax({
				url: ajaxurl,
				type:'POST',
				data: data,
				beforeSend:function(){
					$(".shop-top-widget .right").addClass("loading");
				},
				success: function (results) {
        },
				complete: function (results) {
          console.log(results);
          $(".shop-top-widget .right").removeClass("loading");
          $(".show-results").attr("href", results.responseText);
				}
			});
		});
	}
}

$(window).load(function(){
	if($(".shop-top-widget").length){
		Filters.init();
	}
});
